import React, { useEffect, useState } from 'react';
import Register from './register';


export default function CompanyRegister (props: any) {

  return <Register {...props} />;
}